/* Import Modules */
import $ from "jquery";
import axios, { AxiosRequestConfig } from "axios";
import { rentalContractEditForm,
        isInsUpd, } from "../../variables";
import { getCanvasImageBase64 } from "../../script/canvas";
import { RentalContractValidate } from "../../validation/validation";
import toastr from "toastr";
import { showRentalContractModal } from "../../../compositions/rentContract/modal";

const rentalContractIdNvl = () => {
  return rentalContractEditForm.id == null ? 0 : rentalContractEditForm.id;
};

const getAxiosOptions = () => {
  const axiosOptions: AxiosRequestConfig = {
    xsrfHeaderName: "X-XSRF-TOKEN",
    withCredentials: true,
    url: `/api/rental_contract/${rentalContractIdNvl()}`,
    method: "PATCH",
    data: {
      rentalContract: {
        id: rentalContractEditForm.id,
        scheduleId: rentalContractEditForm.scheduleId,
        slipNo: rentalContractEditForm.slipNo,
        managerId: rentalContractEditForm.managerId,
        dispatchDate: rentalContractEditForm.dispatchDate,
        rentCarNo: rentalContractEditForm.rentCarNo,
        rentCarId: rentalContractEditForm.rentCarId,
        dischargeAmount: rentalContractEditForm.dischargeAmount,
        nocSubscriptionAmount: rentalContractEditForm.nocSubscriptionAmount,
        contractorCompanyName: rentalContractEditForm.contractorCompanyName,
        contractorAddress: rentalContractEditForm.contractorAddress,
        contractorManager: rentalContractEditForm.contractorManager,
        contractorTel: rentalContractEditForm.contractorTel,
        driverName: rentalContractEditForm.driverName,
        driverSex: rentalContractEditForm.driverSex,
        driverBirthday: rentalContractEditForm.driverBirthday,
        driverAddress: rentalContractEditForm.driverAddress,
        driverTel: rentalContractEditForm.driverTel,
        driverLicenseNo: rentalContractEditForm.driverLicenseNo,
        drivingLicenseTypeId: rentalContractEditForm.drivingLicenseTypeId,
        driverLicenseExpireYear: rentalContractEditForm.driverLicenseExpireYear,
        lentDate: rentalContractEditForm.lentDate,
        lentTime: rentalContractEditForm.lentTime,
        lentDateDrivingDistance: rentalContractEditForm.lentDateDrivingDistance,
        returnDate: rentalContractEditForm.returnDate,
        returnTime: rentalContractEditForm.returnTime,
        returnDateDrivingDistance: rentalContractEditForm.returnDateDrivingDistance,
        vehicleInspectionExpiryDate: rentalContractEditForm.vehicleInspectionExpiryDate,
        maintenanceDate: rentalContractEditForm.maintenanceDate,
        maintenancePersonId: rentalContractEditForm.maintenancePersonId,
        usageObjectiveId: rentalContractEditForm.usageObjectiveId,
        destAddress: rentalContractEditForm.destAddress,
        destManager: rentalContractEditForm.destManager,
        destTel: rentalContractEditForm.destTel,
        fuel: rentalContractEditForm.fuel,
      },
      carChecksheets: {
        id: rentalContractEditForm.carChecksheetId,
        rentContractId: rentalContractEditForm.rentContractId,
        checkManagerId: rentalContractEditForm.maintenancePersonId,
        processedDate: rentalContractEditForm.maintenanceDate,
        brakeRoom: rentalContractEditForm.brakeRoom,
        brakeEffective: rentalContractEditForm.brakeEffective,
        brakeFluid: rentalContractEditForm.brakeFluid,
        tireAir: rentalContractEditForm.tireAir,
        tireGrooveDepth: rentalContractEditForm.tireGrooveDepth,
        tireNoDamage: rentalContractEditForm.tireNoDamage,
        batteryFull: rentalContractEditForm.batteryFull,
        batteryElec: rentalContractEditForm.batteryElec,
        lampsNoDefect: rentalContractEditForm.lampsNoDefect,
        lampsNoDamage: rentalContractEditForm.lampsNoDamage,
        engineOil: rentalContractEditForm.engineOil,
        engineFunbelt: rentalContractEditForm.engineFunbelt,
        engineNoDefect: rentalContractEditForm.engineNoDefect,
        speedControl: rentalContractEditForm.speedControl,
        windowLiquid: rentalContractEditForm.windowLiquid,
        windowWiper: rentalContractEditForm.windowWiper,
        equipEtc: rentalContractEditForm.equipEtc,
        driveRecorder: rentalContractEditForm.driveRecorder,
        equipNavi: rentalContractEditForm.equipNavi,
        smokeBomb: rentalContractEditForm.smokeBomb,
        tools: rentalContractEditForm.tools,
        spareTire: rentalContractEditForm.spareTire,
        triangular: rentalContractEditForm.triangular,
        repairKit: rentalContractEditForm.repairKit,
        winch: rentalContractEditForm.winch,
        carWashExterior: rentalContractEditForm.carWashExterior,
        carWashInterior: rentalContractEditForm.carWashInterior,
        scratchCheck: rentalContractEditForm.scratchCheck,
        presence: rentalContractEditForm.presence,
        exteriorCheck: $("#exteriorCheck").val(),
        interiorCheck: $("#interiorCheck").val(),
        memo: rentalContractEditForm.memo,
        signaturePath: getCanvasImageBase64(),
        isAgreement: rentalContractEditForm.isAgreement,
      },
    },
  };

  return axiosOptions;
};

export const storeRentalContractRegistration = async () => {
  const axiosOptions = await getAxiosOptions();
  axios(axiosOptions)
    .then(async(result) => {
        // モーダルデータ再読み込み
        await showRentalContractModal(axiosOptions.data.rentalContract.scheduleId);
        //戻るボタンで画面をリロードするかどうか
        isInsUpd.reload = true;
        toastr.success("登録が完了しました");
    })
    .catch((error) => {
      console.log(error);
      if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
        RentalContractValidate(error.response.data.errors);
      } else {
        toastr.error("登録に失敗しました");
      }
    });
};
